import { toast } from 'sonner'

import { LEDGER_GUIDE_URL } from '~/constants/externalUrls'

import type { EoaSignatureCheck } from '~/utils/smartAccounts/eoaSignature'

/** Surfaces a rejected EOA signature before it reaches the backend. */
export const showEoaSignatureRejectedToast = ({
  check,
  toastId,
}: {
  check: Exclude<EoaSignatureCheck, 'valid'>
  toastId: string
}) => {
  const [title, description] =
    check === 'signed-as-text'
      ? [
          'Unsupported wallet signing',
          "This wallet signs in a format this account can't verify. Try MetaMask.",
        ]
      : [
          'Signature rejected',
          'Signature does not match the connected wallet. Try a different wallet.',
        ]

  toast.error(title, {
    id: toastId,
    description,
    action: {
      label: 'Learn more',
      onClick: () => window.open(LEDGER_GUIDE_URL, '_blank'),
    },
  })
}
